import React from 'react';
import './Icons.css';
import icoAdd from '../../assets/images/icoAdd.png';

export default function AddIcon({ alt }) {
	return <img className='icoAdd' src={icoAdd} alt={alt} title={alt} />;
}
